import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Campaigns from "./pages/Campaigns";
import AIInsights from "./pages/AIInsights";
import { AuthProvider } from "./modules/auth/AuthContext";
import RoleRoute from "./modules/auth/RoleRoute";
import AppLayout from "./modules/layout/AppLayout";
import LoginPage from "./modules/auth/LoginPage";
import LandingPage from "./modules/public/LandingPage";
import ProjectList from "./modules/project/pages/ProjectList";
import ProjectDetail from "./modules/project/pages/ProjectDetail";
import CreateProject from "./modules/project/pages/CreateProject";
import UsersPage from "./modules/user/pages/UsersPage";
import "./App.css";
import "./modules/project/project.css";

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Authenticated app (sidebar shell). AppLayout enforces login. */}
          <Route element={<AppLayout />}>
            {/* Account-wide analytics — admins only */}
            <Route path="/dashboard" element={<RoleRoute><Dashboard /></RoleRoute>} />
            <Route path="/campaigns" element={<RoleRoute><Campaigns /></RoleRoute>} />
            <Route path="/insights" element={<RoleRoute><AIInsights /></RoleRoute>} />

            {/* User management — admin, super_admin, manager */}
            <Route
              path="/users"
              element={
                <RoleRoute roles={["super_admin", "admin", "manager"]}>
                  <UsersPage />
                </RoleRoute>
              }
            />

            {/* Projects — any authenticated user, scoped by role */}
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/projects/new" element={<CreateProject />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/projects/:id/wizard" element={<CreateProject />} />
          </Route>

          {/* Unknown → landing */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
